class MattressQuiz {
  constructor() {
    this.currentQuestion = 1;
    this.totalQuestions = 9;
    this.answers = {};
    this.products = {
      glacier: {
        name: 'Mysa Glacier',
        subtitle: 'The premium hybrid. Support + comfort in perfect balance',
        description: 'Perfect for those who want premium features with excellent cooling and support.',
        features: [
          '5-Zone Pocket Spring System for targeted support',
          'AeroSync HR-GX® Foam for pressure relief',
          'Graphite-Infused Cooling Foam (2x more cooling)',
          'Motion isolation for couples',
          'Hypoallergenic and made in the UK'
        ],
        benefits: [
          'Wake up with less aches and more energy',
          'Stay cool and dry all night',
          'Perfect for side sleepers and couples',
          'Premium hybrid construction'
        ],
        url: '/products/mysa-glacier-premium-hybrid-mattress-for-luxury-sleep',
        image: 'https://cdn.shopify.com/s/files/1/0930/4372/0535/files/1.png?v=1752567169'
      },
      breeze: {
        name: 'Mysa Breeze',
        subtitle: 'Foam comfort with cooling tech- breathable comfort on a budget',
        description: 'Ideal for budget-conscious shoppers who still want quality cooling comfort.',
        features: [
          '7-Zone Orthopaedic Base Foam for spinal alignment',
          'AeroSync HR-GX® + Visco Comfort Foam',
          'Graphite-Infused AeroSpheric® Foam for cooling',
          'BeFree® 3D Mesh Knit Cover for breathability',
          'Single-sided foam construction'
        ],
        benefits: [
          'Cooling comfort without springs',
          'Perfect for lightweight sleepers',
          'Pressure relief from head to toe',
          'Great value for money'
        ],
        url: '/products/mysa-breeze-cooling-foam-mattress-with-orthopaedic-support',
        image: 'https://cdn.shopify.com/s/files/1/0930/4372/0535/files/1_54b570a1-5742-42a1-a748-9bfd1e5ad115.png?v=1754907300'
      },
      duo: {
        name: 'Mysa Duo',
        subtitle: 'Two mattresses in one. Flip it to fit your life',
        description: 'Perfect for those unsure about firmness or couples with different preferences.',
        features: [
          'Double-sided firmness (medium and firmer)',
          'AeroSync HR-GX® Foam on both sides',
          'Over 20 pressure-relieving zones',
          'BeFree® 3D Mesh Cover for airflow',
          'Flippable design for versatility'
        ],
        benefits: [
          'Two firmness levels in one mattress',
          'Perfect if youre unsure about firmness',
          'Great for couples with different preferences',
          'Helps with back pain and circulation'
        ],
        url: '/products/mysa-duo-dual-firmness-hybrid-mattress',
        image: 'https://cdn.shopify.com/s/files/1/0930/4372/0535/files/1_be097e50-8d68-4813-aa5b-ec021618b36f.png?v=1754907511'
      }
    };
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateProgress();
    this.updateNavigation();
  }

  bindEvents() {
  // Navigation buttons
  document.getElementById('prev-btn')?.addEventListener('click', () => this.prevQuestion());
  document.getElementById('finish-btn')?.addEventListener('click', () => this.calculateResults());
  document.getElementById('retake-quiz-btn')?.addEventListener('click', () => this.retakeQuiz());

  // Answer selection
  document.addEventListener('change', (e) => {
    if (e.target.type === 'radio') {
      this.saveAnswer(e.target);
      this.updateNavigation();

      // Auto-advance if NOT on the last question
      if (this.currentQuestion < this.totalQuestions) {
        setTimeout(() => this.nextQuestion(), 200); // small delay for click animation
      }
    }
  });
}


  saveAnswer(input) {
    const questionName = input.name;
    const questionValue = input.value;
    
    this.answers[questionName] = {
      value: questionValue,
      weights: {
        glacier: parseInt(input.dataset.weightGlacier) || 0,
        breeze: parseInt(input.dataset.weightBreeze) || 0,
        duo: parseInt(input.dataset.weightDuo) || 0
      }
    };
  }

  nextQuestion() {
    if (this.currentQuestion < this.totalQuestions) {
      // Hide current question
      document.querySelector(`[data-question="${this.currentQuestion}"]`).classList.remove('active');
      
      // Show next question
      this.currentQuestion++;
      document.querySelector(`[data-question="${this.currentQuestion}"]`).classList.add('active');
      
      this.updateProgress();
      this.updateNavigation();
      this.scrollToTop();
    }
  }

  prevQuestion() {
    if (this.currentQuestion > 1) {
      // Hide current question
      document.querySelector(`[data-question="${this.currentQuestion}"]`).classList.remove('active');
      
      // Show previous question
      this.currentQuestion--;
      document.querySelector(`[data-question="${this.currentQuestion}"]`).classList.add('active');
      
      this.updateProgress();
      this.updateNavigation();
      this.scrollToTop();
    }
  }

  updateProgress() {
    const progressPercent = (this.currentQuestion / this.totalQuestions) * 100;
    document.getElementById('progress-fill').style.width = `${progressPercent}%`;
    document.getElementById('current-question').textContent = this.currentQuestion;
    document.getElementById('total-questions').textContent = this.totalQuestions;
  }

  updateNavigation() {
    const prevBtn = document.getElementById('prev-btn');
    const nextBtn = document.getElementById('next-btn');
    const finishBtn = document.getElementById('finish-btn');
    
    // Show/hide previous button
    if (this.currentQuestion === 1) {
      prevBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'inline-block';
    }
    
    // Show next or finish button
    if (this.currentQuestion === this.totalQuestions) {
      nextBtn.style.display = 'none';
      finishBtn.style.display = 'inline-block';
    } else {
      nextBtn.style.display = 'inline-block';
      finishBtn.style.display = 'none';
    }
    
    // Enable/disable next/finish button based on answer
    const currentQuestionEl = document.querySelector(`[data-question="${this.currentQuestion}"]`);
    const hasAnswer = currentQuestionEl.querySelector('input[type="radio"]:checked');
    
    if (this.currentQuestion === this.totalQuestions) {
      finishBtn.disabled = !hasAnswer;
    } else {
      nextBtn.disabled = !hasAnswer;
    }
  }

  calculateResults() {
    const scores = {
      glacier: 0,
      breeze: 0,
      duo: 0
    };

    // Calculate weighted scores
    Object.values(this.answers).forEach(answer => {
      scores.glacier += answer.weights.glacier;
      scores.breeze += answer.weights.breeze;
      scores.duo += answer.weights.duo;
    });

    // Find the product with highest score
    const recommendedProduct = Object.keys(scores).reduce((a, b) => 
      scores[a] > scores[b] ? a : b
    );

    this.showResults(recommendedProduct, scores);
  }

  showResults(productKey, scores) {
    const product = this.products[productKey];
    
    // Hide quiz questions and show results
    document.querySelectorAll('.quiz-question').forEach(q => q.classList.remove('active'));
    document.querySelector('.quiz-navigation').style.display = 'none';
    document.querySelector('.quiz-progress').style.display = 'none';
    document.getElementById('quiz-results').style.display = 'block';

    // Populate results
    const resultsContainer = document.getElementById('recommended-product');
    resultsContainer.innerHTML = `
      <div class="product-result">
        <div class="product-image">
          <img src="${product.image}" alt="${product.name}" onerror="this.style.display='none'">
        </div>
        <div class="product-details">
          <h3 class="product-name">${product.name}</h3>
          <p class="product-subtitle">${product.subtitle}</p>
          <p class="product-description">${product.description}</p>
          
          <div class="product-features">
            <h4>Key Features:</h4>
            <ul>
              ${product.features.map(feature => `<li>${feature}</li>`).join('')}
            </ul>
          </div>
          
        
          
          <div class="confidence-score">
            <div class="score-label">Match Confidence:</div>
            <div class="score-bar">
              <div class="score-fill" style="width: ${this.calculateConfidence(scores, productKey)}%"></div>
            </div>
            <div class="score-text">${this.calculateConfidence(scores, productKey)}% match</div>
          </div>
        </div>
      </div>
    `;

    // Update view product button
    document.getElementById('view-product-btn').href = product.url;
    
    this.scrollToTop();
  }

  calculateConfidence(scores, productKey) {
    const maxScore = Math.max(...Object.values(scores));
    const selectedScore = scores[productKey];
    return Math.round((selectedScore / maxScore) * 100);
  }

  retakeQuiz() {
    // Reset quiz state
    this.currentQuestion = 1;
    this.answers = {};
    
    // Clear all radio buttons
    document.querySelectorAll('input[type="radio"]').forEach(input => {
      input.checked = false;
    });
    
    // Show first question
    document.querySelectorAll('.quiz-question').forEach(q => q.classList.remove('active'));
    document.querySelector('[data-question="1"]').classList.add('active');
    
    // Hide results and show quiz elements
    document.getElementById('quiz-results').style.display = 'none';
    document.querySelector('.quiz-navigation').style.display = 'flex';
    document.querySelector('.quiz-progress').style.display = 'block';
    
    // Update progress and navigation
    this.updateProgress();
    this.updateNavigation();
    this.scrollToTop();
  }

  scrollToTop() {
    document.querySelector('.mattress-quiz-container').scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Initialize quiz when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  new MattressQuiz();
});

// Track quiz completion for analytics (optional)
window.quizCompleted = function(productRecommendation) {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'quiz_completed', {
      'custom_map': {'dimension1': productRecommendation}
    });
  }
  
  if (typeof fbq !== 'undefined') {
    fbq('track', 'CompleteRegistration', {
      content_name: 'Mattress Quiz',
      content_category: productRecommendation
    });
  }
};